'use strict';
import Util from './util';


const LOG_LEVEL = 4;

function consoleOut(type, lvl, args) {
    let fn = console[type];
    if (lvl <= LOG_LEVEL && !Util.isNull(fn)) fn.apply(console, args);
}

export function trace(...args) {
    args.unshift('[TRC]');
    consoleOut('log', 4, args)
}

export function log(...args) {
    args.unshift('[LOG]');
    consoleOut('log', 3, args)
}

export function warn(...args) {
    args.unshift('[WRN]');
    consoleOut('warn', 2, args)
}

export function error(...args) {
    args.unshift('[ERR]');
    consoleOut('error', 1, args)
}

export default {
    trace,
    log,
    warn,
    error
}
